import styled from 'styled-components';

const Error = styled.span`
  color: ${props => props.theme.colors.error};
  font-size: 12px;
  order: 3;
`;

export default Error;
